import React, { FC } from 'react';
import { Icon } from '../../Icon/Icon';
require("./Search-Icon.css");
var styles = {
  "Root": "Search-Icon-module-Root_2D8"
};
export const SearchIcon = ({
  showIcon
}) => showIcon ? /*#__PURE__*/React.createElement(Icon, {
  name: "search",
  size: "m",
  className: styles.Root
}) : null;